import { PortableText } from '@portabletext/react';
import { Box, Flex, Heading } from '@chakra-ui/react';
import styles from './BlogHeader.module.css';

export default function BlogHeader({
  title,
  description,
  level
}: {
  title: string;
  description?: any[];
  level: 1 | 2;
}) {
  switch (level) {
    case 1:
      return (
        <Flex
          mb={{ base: 10, md: 12 }}
          mt={16}
          direction={{ base: 'column', md: 'row' }}
          alignItems={{ base: 'center', md: 'space-between' }}
        >
          <Heading
            as='h1'
            size={{ base: '6xl', md: '8xl' }}
            pr={{ base: 0, md: 8 }}
            fontWeight='extrabold'
            className='font-bold leading-tight tracking-tighter'
          >
            {title}
          </Heading>
          <Heading
            as='h4'
            mt={5}
            textAlign={{ base: 'center', md: 'left' }}
            size='lg'
            pl={{ base: 0, md: 8 }}
            className={styles.portableText}
          >
            <PortableText value={description} />
          </Heading>
        </Flex>
      );

    case 2:
      return (
        <Box>
          <Heading
            as='h1'
            size={{ base: 'md', md: '5xl' }}
            fontSize={{ base: 'xl', md: '6xl' }}
            fontWeight='extrabold'
            mb={10}
            mt={8}
            className='leading-tight tracking-tight md:tracking-tighter'
          >
            {title}
          </Heading>
        </Box>
      );

    default:
      throw new Error(`Invalid level: ${JSON.stringify(level) || typeof level}, only 1 or 2 are allowed`);
  }
}
